import { VREditorRoomPanel } from './room-panel.js';
import { VREditorWelcomePanel } from './welcome-panel.js';
import { VREditorLayoutPanel } from './layout-panel.js';
import { VREditorHotspotPanel } from './hotspot-panel.js';
import { VREditorColorPanel } from './color-panel.js';
import { VREditorControlPanel } from './control-panel.js';
import { VREditorBoardPanel } from './board-panel.js';
import { VREditorPeoplePanel } from './people-panel.js';
import { VRNerdPanel } from './nerd-panel.js';
import { VREditorCustomOverlayPanel } from './custom-overlay-panel.js';
import { VREditorBrandingPanel } from './subpanels/branding-panel.js';

export class VREditorPanel {
  constructor (vr, editor) {
    this.vr = vr;

    this.subPanels = [];

    const panel = $('<div class="ca-vr_editorpanel"></div>');
    this.vr.wrapper.append(panel);

    // Header
    const header = $('<div class="ca-vr_editorpanel-header">Room Editor</div>');
    panel.append(header);

    // Close
    const closeButton = $(
      '<div class="ca-vr_editorpanel-header-close fa fas fa-times"></div>'
    );
    header.append(closeButton);
    closeButton.on(
      'click',
      function () {
        this.vr.openEditor(false);
      }.bind(this)
    );

    // Intro
    const intro = $(
      '<div class="ca-vr_editorpanel-intro">Use the options below to edit your virtual room.</div>'
    );
    panel.append(intro);

    // List
    this.menu = $('<ul class="ca-vr_editorpanel-menu"></ul>');
    panel.append(this.menu);

    // Room
    // console.log(editor);
    if (editor.devMode) {
      this.addSubPanel(new VREditorRoomPanel(vr, editor));
    }

    this.addSubPanel(new VREditorBrandingPanel(vr, editor));

    // Welcome
    this.addSubPanel(new VREditorWelcomePanel(vr, editor));

    // Layout
    if (editor.devMode) {
      this.addSubPanel(new VREditorLayoutPanel(vr, editor));
    }

    // Colors
    // this.addSubPanel(new VREditorColorPanel(vr, editor));

    // Controls
    this.addSubPanel(new VREditorControlPanel(vr, editor));

    // Boards
    if (editor.devMode) {
      this.addSubPanel(new VREditorBoardPanel(vr, editor));
    }

    // Custom Overlays
    if (editor.devMode) {
      this.addSubPanel(new VREditorCustomOverlayPanel(vr, editor));
    }

    // Hotspots
    this.addSubPanel(new VREditorHotspotPanel(vr, editor));

    // People
    if (editor.devMode) {
      this.addSubPanel(new VREditorPeoplePanel(vr, editor));
    }

    // Developer
    // if (vr.options.devMode) this.addSubPanel(new VRNerdPanel(vr, editor));

    this.resize();
    $(window).on(
      'resize',
      function () {
        this.resize();
      }.bind(this)
    );
  }

  addSubPanel (subPanel) {
    this.subPanels.push(subPanel);
    this.menu.append(subPanel.item);

    subPanel.itemLabel.on(
      'click',
      function () {
        this.openSubPanel(subPanel.id, false);
      }.bind(this)
    );
  }

  openSubPanel (id, force) {
    let active;

    this.subPanels.forEach(
      function (i) {
        if (
          i.item.hasClass('ca-vr_editorpanel-menu_' + id) &&
          (!i.item.hasClass('active') || force)
        ) {
          active = i;
          i.item.addClass('active');
          if (i.openPanel()) {
            i.openPanel();
          }
          i.open();
        } else {
          i.item.removeClass('active');
          i.setObject(null);
          i.close();
        }
      }
    );

    return active;
  }

  setObject (obj, fireAssetChange) {
    this.subPanels.forEach(function (i) {
      i.setObject(obj, fireAssetChange);
    });
  }

  open () {}
  resize () {}
}
